import React, { useState } from 'react';
import { Popover } from '../../..';
import { FilterIcon } from '../../../../icons';
import { Control, IconContainer } from '../RightControl';
import { FilterContainer } from './FilterContainer';
import { FilterSectionLabel } from './FilterSectionLabel';
export const HeaderFilter = ({ trigger, children }) => {
    const [active, setActive] = useState(false);
    return (React.createElement(Control, { className: active ? 'active' : '' },
        React.createElement(Popover, { content: React.createElement(FilterContainer, null, children), trigger: trigger || 'click', 
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            getPopupContainer: (triggerElement) => triggerElement.parentElement, onVisibleChange: setActive },
            React.createElement(IconContainer, null,
                React.createElement(FilterIcon, null)))));
};
HeaderFilter.SectionLabel = FilterSectionLabel;
